const topicList = [
  { tag: '悬疑烧脑', heat: '9.8w讨论', icon: 'ri-mind-map' },
  { tag: '甜宠恋爱', heat: '8.6w讨论', icon: 'ri-heart-pulse-line' },
  { tag: '科幻大片', heat: '7.4w讨论', icon: 'ri-planet-line' },
  { tag: '国产好剧', heat: '15w讨论', icon: 'ri-flag-2-line' },
  { tag: '韩剧推荐', heat: '11w讨论', icon: 'ri-kakao-talk-line' },
  { tag: '美剧精选', heat: '9.2w讨论', icon: 'ri-earth-line' },
  { tag: '动漫新番', heat: '12w讨论', icon: 'ri-ghost-smile-line' },
  { tag: '高分电影', heat: '13w讨论', icon: 'ri-star-line' },
  { tag: '美食纪录', heat: '5.3w讨论', icon: 'ri-restaurant-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-4">
            大家都在聊
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            追剧达人都在讨论的热门话题，看看有没有你感兴趣的
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicList.map((item) => (
            <div
              key={item.tag}
              className="group flex items-center gap-3 px-5 py-3 bg-background-50 rounded-full hover:bg-primary-50/60 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100/60 text-accent-600 group-hover:bg-accent-200/60 transition-colors shrink-0">
                <i className={`${item.icon} text-sm`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}